import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropzoneModule } from 'ngx-dropzone-wrapper';

import { ImportComponent } from './import.component';
import { HistoricComponent } from '../../components/historic/historic.component';
import { SearchMusicsComponent } from '../../components/searchmusics/searchMusics.component';

import { DropzoneService } from '../../providers/Import/dropzone.service';
import { SearchMusicsService } from '../../providers/Import/searchMusics.service';
import { HistoricService } from '../../providers/Import/historic.service';

import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';

import { MinutesSecondsPipe } from '../../components/searchmusics/minutes-seconds.pipe';

@NgModule({
  declarations: [
    ImportComponent,
    HistoricComponent,
    SearchMusicsComponent,
    MinutesSecondsPipe
  ],
  imports: [
    CommonModule,
    DropzoneModule,
    MatButtonModule,
    MatTableModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatBottomSheetModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatTabsModule
  ],
  providers: [
    DropzoneService,
    SearchMusicsService,
    HistoricService
  ]
})
export class ImportModule { }
